import * as React from 'react';
import { HitsPerPage } from 'react-instantsearch';

function buildItems(initialValue = 12) {
  initialValue = parseInt(initialValue)
  let itemsList = [12, 24, 36];

  if (!itemsList.includes(initialValue)) {
    itemsList = [initialValue, ...itemsList];
  }

  itemsList.sort((a, b) => a - b);
  
  const items = itemsList
    .map(item => ({
      value: item, label: `${item}`, key: `key:${item}`,
    }))
    .map(item => {
      item.default = item.value === initialValue
      return item;
    });

  if (items.every(item => !item.default)) {
    items[0].default = true;
  }

  return items;
}

const FacetedSearchHitsPerPage = (props) => {
  const {itemsPerPage = 12} = props;

  return (
    <div className='faceted-search-per-page'>
      <div className='items-per-page'>
        <span>{I18n.t('faceted_search.results_per_page.label')}</span>
        <HitsPerPage items={buildItems(itemsPerPage)}/>
        <span>{I18n.t('faceted_search.results_per_page.unit')}</span>
      </div>
    </div>
  );
};

export default FacetedSearchHitsPerPage;
